import * as CURRENCY_API from '@/api/currency'

export default {
  state: {
    codes: {},
    exchangeRates: []
  },
  getters: {
    currencyCodes: (state) => {
      return state.codes
    },
    currencyExchangeRates: (state) => {
      return state.exchangeRates
    }
  },
  mutations: {
    setCurrencyCodes (state, data) {
      state.codes = data
    },
    setCurrencyExchangeRates (state, data) {
      state.exchangeRates = data
    }
  },
  actions: {
    getCurrencyCodes ({ commit }) {
      return CURRENCY_API.getCurrencyCodes().then(resp => {
        commit('setCurrencyCodes', resp.data)
        return resp
      })
    },
    getCurrencyExchangeRates ({ commit }) {
      return CURRENCY_API.getCurrencyExchangeRates().then(resp => {
        commit('setCurrencyExchangeRates', resp.data)
        return resp
      })
    }
  }
}
